// Script para insertar <br> después de "tracción" en la sección específica
  function insertLineBreakAfterTraccion() {
    const section = document.querySelector('#shopify-section-template--26166835446043__rich_text_yUKkgh');
    if (!section) return;

    const heading = section.querySelector('.h1.hyphenate');
    if (!heading) return;

    const text = heading.innerHTML;
    if (text.includes('tracción')) {
      heading.innerHTML = text.replace(/tracción\s+/, 'tracción<br>');
      console.log('[line-break] <br> insertado después de "tracción"');
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertLineBreakAfterTraccion);
  } else {
    insertLineBreakAfterTraccion();
  }